module.exports = __webpack_public_path__ + "assets/img/2.b57c65ba.gif";